import i18n from "../../../lang/base";
import { FONT } from "../../../value/staticValues";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import { ListActionMenu, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";


import SecurityGroupAdd from "./SecurityGroupAdd";
import SecurityGroupUpdate from "./SecurityGroupUpdate";
import { parseLocaleDatetime } from "common/util";

export interface SecurityGroupRuleData {
    security_group_rule_id: string,
    security_group_rule_type_code: string,
    direction_type_code: string,
    open_port_type_code: string,
    remote_type_code: string,
    min_port: number,
    max_port: number,
    ports: {
        open_port_type_code: string,
        min_port: number,
        max_port: number,
    },
    remote_cidr: string|null,
    ip_protocol: number,
    remote_security_group_id: string|null,
    remote_security_group_name: string|null,
    create_ts: string,
    update_ts: string
}
export interface SecurityGroupDetailData {
    security_group_id: string,
    security_group_name: string,
    security_group_description: string,
    default_yn: boolean,
    project: {
      project_id: string,
      project_name: string
    },
    security_group_rules:SecurityGroupRuleData[],
    create_ts: string,
    update_ts: string
}

export const initSecurityGroupDetailData = {
    security_group_id: "",
    security_group_name: "",
    security_group_description: "",
    default_yn: false,
    project: {
      project_id: "",
      project_name: ""
    },
    security_group_rules: [
      {
        security_group_rule_id: "",
        security_group_rule_type_code: "",
        direction_type_code: "",
        open_port_type_code: "",
        remote_type_code: "",
        min_port: 0,
        max_port: 0,
        ports: {
            open_port_type_code: "",
            min_port: 0,
            max_port: 0,
        },
        remote_cidr: "",
        ip_protocol: 0,
        remote_security_group_id: "",
        remote_security_group_name: "",
        create_ts: "",
        update_ts: ""
      }
    ],
    create_ts: "",
    update_ts: ""
}

export interface securityGroupData {
    security_group_id: string,
    security_group_name: string,
    security_group_description: string|null,
    default_yn: boolean,
    project: {
      project_id: string,
      project_name: string
    },
    security_group_rule_count: number,
    create_ts: string,
    update_ts: string
}
export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("SECURITY_GROUP_ADD_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "SECURITY_GROUP_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "SECURITY_GROUP_DELETE",
        },
    },
    {
        id: 3,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "SECURITY_GROUP_SYNC",
        }
    },
];


export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("SECURITY_GROUP_NAME_TEXT"),
        accessor: "security_group_name",
        disableSortBy: false,
        style: {
            width: "350px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("DESCRIPTION_TEXT"),
        accessor: "security_group_description",
        disableSortBy: true,
        style: {
            width: "350px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("PROJECT_DEFAULT_TEXT"),
        accessor: "default_yn",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.greenText}}>{value === true ? <StatusStableImg /> : <StatusBlockImg />}</div>)
    },
    {
        Header: i18n.t("SECURITY_GROUP_RULE_COUNT_TEXT"),
        accessor: "security_group_rule_count",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.blueText}}>{value}{i18n.t("UNIT_TEXT")}</div>)
    },
    {
        Header: i18n.t("PROJECT_NAME_TEXT"),
        accessor: "project",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value?.project_name ? value.project_name : ""}</div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.dateContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    }
];


export const securityGroupAddModalContent = {
    title: i18n.t("SECURITY_GROUP_CREATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <SecurityGroupAdd />,
}

export const securityGroupUpdateModalContent = {
    title: i18n.t("SECURITY_GROUP_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            deleteButtonYn: true,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <SecurityGroupUpdate />,
}

const className = {
    statusContainer: {
        width: 56,
        display: "flex", Jusitipy: "center", justifyContent: "center",
        borderRadius: 10,
        backgroundColor: "#b6bfce",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#fff"
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    greenText: {
        color: "#3a8344"
    },
    blueText: {
        color: "#0853fb"
    },
    purpleText: {
        color: "#7066f1"
    },
}